import { gql, useQuery } from '@apollo/client';

export interface JunoTmsIssuesVars {
    collectionIdentifier: string;
}

export interface JunoTmsIssue {
    issueType: string;
    tmsUpdateTimestamp: Date;
    tmsCreateTimestamp: Date;
    details: string;
    supportSOP: string;
    serviceSOP: string;
}

export interface JunoTmsIssuesData {
    getJunoTmsIssues: JunoTmsIssue[];
}
const GQL_COLLECTION_TMS_ISSUES = gql`
  query getCollectionTMSIssues($collectionIdentifier: String!) {
      getJunoTmsIssues(collectionIdentifier: $collectionIdentifier)  {
        issueType
        tmsUpdateTimestamp
        tmsCreateTimestamp
        details
        supportSOP
        serviceSOP
      }
  }
`;

export const useJunoTmsQuery = (vars: JunoTmsIssuesVars) => {
    return useQuery<JunoTmsIssuesData, JunoTmsIssuesVars>(GQL_COLLECTION_TMS_ISSUES, {
        variables: { ...vars }
    });
};
